/* F&P collection and search pages (V10): feedback while filters apply, and the sticky filter bar's hairline.
   State lives on <html>, outside the sections Horizon re-renders (its morph would wipe it). */
const html = document.documentElement;

/* While filters, sorting or the gender filter update the grid: dim it and run a thin line (after 120ms, so fast
   answers never flash); clear when the update promise settles. New cards then rise in (fp-v10-shop.css). */
let busyTimer = null;
const busy = (on) => {
  clearTimeout(busyTimer);
  if (on) { busyTimer = setTimeout(() => { html.classList.add('fp-busy'); document.querySelector('main')?.setAttribute('aria-busy', 'true'); }, 120); }
  else { html.classList.remove('fp-busy'); document.querySelector('main')?.removeAttribute('aria-busy'); }
};
const watch = (event) => {
  const promise = event?.detail?.promise ?? event?.promise;
  busy(true);
  Promise.resolve(promise).finally(() => {
    busy(false);
    const grid = document.querySelector('main .product-grid');
    if (grid) window.fpMotion?.scan(grid);
  });
  // a stuck request never leaves the grid dimmed
  setTimeout(() => busy(false), 8000);
};
import('@shopify/events').then(({ StandardEvents }) => {
  [StandardEvents?.collectionUpdate, StandardEvents?.searchUpdate].filter(Boolean).forEach((name) => document.addEventListener(name, watch, true));
}).catch(() => {});
// the gender filter loads a new page: show the feedback at once
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-fp-gender-filter] a, [data-fp-gender-filter] input, .fp-gender-filter a')) busy(true);
}, true);
addEventListener('pageshow', () => busy(false));

/* Sticky filter bar: it sticks to the header's real bottom edge (owner 10-06 saw a strip of products between them where
   the measured --header-height and the header's height differed), and once there takes the hairline. */
let queued = false;
const headerEl = document.querySelector('header-component, #header-group header, header.header');
const stuck = () => {
  queued = false;
  const bar = document.querySelector('main .facets-block-wrapper--horizontal:not(.hidden), main .facets-mobile-wrapper');
  const edge = headerEl ? Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom)) : null;
  if (edge !== null) html.style.setProperty('--fp-sticky-top', `${edge}px`);
  if (!bar || !bar.offsetHeight) { html.classList.remove('fp-filter-stuck'); return; }
  const header = edge ?? (parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0);
  // F&P pages scroll inside .page-wrapper (html and body never scroll), so read its offset, not the window's
  const scrolled = (document.querySelector('.page-wrapper')?.scrollTop || 0) + scrollY;
  html.classList.toggle('fp-filter-stuck', bar.getBoundingClientRect().top <= header + 3 && scrolled > 0);
};
const onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(stuck); } };
document.addEventListener('scroll', onScroll, { passive: true, capture: true });
addEventListener('resize', onScroll, { passive: true });
if (headerEl && 'ResizeObserver' in window) new ResizeObserver(onScroll).observe(headerEl);
document.fonts?.ready.then(onScroll);
stuck();
